// src/components/SectionWrapper.jsx
import { motion } from "framer-motion";

const SectionWrapper = ({ children, animation = "fade-up", className = "", id }) => {
  const variants = {
    "fade-up": { hidden: { opacity: 0, y: 50 }, visible: { opacity: 1, y: 0 } },
    "fade-right": { hidden: { opacity: 0, x: -50 }, visible: { opacity: 1, x: 0 } },
    "fade-left": { hidden: { opacity: 0, x: 50 }, visible: { opacity: 1, x: 0 } },
    "zoom-in": { hidden: { opacity: 0, scale: 0.9 }, visible: { opacity: 1, scale: 1 } },
  };

  return (
    <motion.section
      id={id}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.2 }} // triggers when 20% is visible
      transition={{ duration: 0.8, ease: "easeOut" }}
      variants={variants[animation]}
      className={`py-12 container mx-auto ${className}`}
    >
      {children}
    </motion.section>
  );
};

export default SectionWrapper;
